export default "__VITE_ASSET__Clcf75w___"